import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider} from 'firebase/auth'
const firebaseConfig = {
  apiKey: "AIzaSyA7DCxlwFSry4ZPZyDiSbMUBryAZ40Ge-E",
  authDomain: "elite-luxora.firebaseapp.com",
  projectId: "elite-luxora",
  storageBucket: "elite-luxora.firebasestorage.app",
  messagingSenderId: "958395397540",
  appId: "1:958395397540:web:08c75f712836990e21fd31",
  measurementId: "G-NY5V59WPRY",
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();
export { auth, provider };
